import type { FunctionComponent } from 'react';
import YearsField from './YearsField';

const NotEmployed: FunctionComponent = function () {
  return <YearsField status="not_employed" />;
};

export default NotEmployed;
